import { render, staticRenderFns } from "./ManageBetslipV2.vue?vue&type=template&id=0134a1f3&scoped=true&"
import script from "./ManageBetslipV2.vue?vue&type=script&lang=js&"
export * from "./ManageBetslipV2.vue?vue&type=script&lang=js&"
import style0 from "./ManageBetslipV2.vue?vue&type=style&index=0&id=0134a1f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134a1f3",
  null
  
)

export default component.exports